<div class="page-wrapper">
  <div class="form-card">

    <!-- Card Header -->
    <div class="card-header-block">
      <div class="header-left">
        <img src="logo-login.svg" alt="aInstitute Logo" class="card-logo" />
        <div class="progress-wrap">
          <div class="progress-bar">
            <div class="progress-fill" style="width: 50%"></div>
          </div>
          <span class="progress-label">Step 2 of 4 — Institution Details</span>
        </div>
      </div>
    </div>

    <!-- Intro Banner -->
    <div class="intro-banner">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
        <path d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <span>Almost there! Complete the form below to finalise institution onboarding.</span>
    </div>

    <form [formGroup]="registerForm" (ngSubmit)="submit()" novalidate>
      <div class="form-body">

        <!-- ════ ADMINISTRATOR DETAILS ════ -->
        <section class="form-section">
          <h2 class="section-heading">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            Administrator Details
          </h2>

          <div class="grid-3">
            <div class="field-group">
              <label class="field-label" for="firstName">First Name <span class="required">*</span></label>
              <input id="firstName" class="field-input" formControlName="firstName" placeholder="Prakash" type="text" />
            </div>
            <div class="field-group">
              <label class="field-label" for="middleName">Middle Name</label>
              <input id="middleName" class="field-input" formControlName="middleName" placeholder="Kumar" type="text" />
            </div>
            <div class="field-group">
              <label class="field-label" for="lastName">Last Name <span class="required">*</span></label>
              <input id="lastName" class="field-input" formControlName="lastName" placeholder="Sharma" type="text" />
            </div>
          </div>

          <div class="grid-2">
            <div class="field-group">
              <label class="field-label" for="dob">Date of Birth</label>
              <input id="dob" type="date" class="field-input" formControlName="dob" />
            </div>
            <div class="field-group">
              <label class="field-label" for="gender">Gender</label>
              <select id="gender" class="field-input field-select" formControlName="gender">
                <option value="">Select Gender</option>
                @for (g of genders; track g.value) {
                  <option [value]="g.value">{{ g.label }}</option>
                }
              </select>
            </div>
          </div>

          <!-- Email verification -->
          <div class="verify-block">
            <p class="verify-block-label">Email Verification <span class="required">*</span></p>

            <div class="verify-row" *ngIf="!registerForm.value.emailVerified">
              <div class="verify-input-wrap">
                <input
                  *ngIf="!emailOtpSent"
                  class="field-input"
                  formControlName="email"
                  placeholder="admin@institution.edu"
                  type="email"
                />
                <input
                  *ngIf="emailOtpSent"
                  class="field-input"
                  formControlName="emailOtp"
                  placeholder="Enter 6-digit OTP"
                  maxlength="6"
                />
              </div>
              <button type="button" class="btn-verify" *ngIf="!emailOtpSent" (click)="sendEmailOtp()" [disabled]="emailVerifying">
                {{ emailVerifying ? 'Sending…' : 'Send OTP' }}
              </button>
              <button type="button" class="btn-verify btn-confirm" *ngIf="emailOtpSent" (click)="verifyEmailOtp()" [disabled]="emailConfirming">
                {{ emailConfirming ? 'Verifying…' : 'Confirm OTP' }}
              </button>
            </div>

            <div class="verified-badge" *ngIf="registerForm.value.emailVerified">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              Email verified — {{ registerForm.get('email')?.value }}
              <button type="button" class="btn-change" (click)="changeEmail()">Change Email</button>
            </div>
            <p class="otp-error" *ngIf="emailOtpError">{{ emailOtpError }}</p>
          </div>

          <!-- Mobile verification -->
          <div class="verify-block">
            <p class="verify-block-label">Mobile Verification <span class="required">*</span></p>

            <div class="verify-row" *ngIf="!registerForm.value.mobileVerified">
              <div class="verify-input-wrap">
                <input
                  *ngIf="!mobileOtpSent"
                  class="field-input"
                  formControlName="mobile"
                  placeholder="+91 98765 43210"
                  type="tel"
                />
                <input
                  *ngIf="mobileOtpSent"
                  class="field-input"
                  formControlName="mobileOtp"
                  placeholder="Enter 6-digit OTP"
                  maxlength="6"
                />
              </div>
              <button type="button" class="btn-verify" *ngIf="!mobileOtpSent" (click)="sendMobileOtp()" [disabled]="mobileVerifying">
                {{ mobileVerifying ? 'Sending…' : 'Send OTP' }}
              </button>
              <button type="button" class="btn-verify btn-confirm" *ngIf="mobileOtpSent" (click)="verifyMobileOtp()" [disabled]="mobileConfirming">
                {{ mobileConfirming ? 'Verifying…' : 'Confirm OTP' }}
              </button>
            </div>

            <div class="verified-badge" *ngIf="registerForm.value.mobileVerified">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              Mobile verified — {{ registerForm.get('mobile')?.value }}
              <button type="button" class="btn-change" (click)="changeMobile()">Change Mobile</button>
            </div>
            <p class="otp-error" *ngIf="mobileOtpError">{{ mobileOtpError }}</p>
          </div>
        </section>

        <!-- ════ INSTITUTE DETAILS ════ -->
        <section class="form-section">
          <h2 class="section-heading">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0H5m14 0h-5m-9 0H3m2 0h5m0 0V9a1 1 0 011-1h2a1 1 0 011 1v12m-4 0h4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            Institute Details
          </h2>

          <div class="grid-2">
            <div class="field-group">
              <label class="field-label">Institute Name <span class="required">*</span></label>
              <input class="field-input" formControlName="name" placeholder="Springfield Academy" type="text" />
            </div>
            <div class="field-group">
              <label class="field-label">Institute Type <span class="required">*</span></label>
              <select class="field-input field-select" formControlName="instituteType">
                <option value="">Select Type</option>
                @for (e of instituteTypes; track e.value) {
                  <option [value]="e.value">{{ e.label }}</option>
                }
              </select>
            </div>
          </div>

          <!-- Logo Upload -->
          <div class="logo-upload-block">
            <p class="verify-block-label">Institute Logo</p>
            <p class="logo-hint">Accepted formats: JPG, PNG, GIF, SVG &nbsp;·&nbsp; Max size: <strong>2 MB</strong></p>

            <!-- Idle: no file chosen yet -->
            <div class="logo-drop-area" *ngIf="!logoPreviewUrl && !logoUploading">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                <path d="M4 16l4-4 4 4 4-6 4 6M3 20h18M3 4h18" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span class="logo-drop-label">Click to upload your institute logo</span>
              <label class="btn-upload-label">
                Choose Image
                <input type="file" accept="image/*" (change)="onLogoFileSelected($event)" hidden />
              </label>
            </div>

            <!-- Uploading: progress bar -->
            <div class="logo-uploading" *ngIf="logoUploading">
              <img [src]="logoPreviewUrl" alt="Logo preview" class="logo-thumb" />
              <div class="upload-progress-wrap">
                <div class="upload-progress-info">
                  <span>Uploading…</span>
                  <span class="upload-pct">{{ logoUploadProgress }}%</span>
                </div>
                <div class="upload-progress-bar">
                  <div class="upload-progress-fill" [style.width.%]="logoUploadProgress"></div>
                </div>
              </div>
            </div>

            <!-- Uploaded: success state -->
            <div class="logo-uploaded" *ngIf="logoUploadUrl && !logoUploading">
              <img [src]="logoPreviewUrl" alt="Logo preview" class="logo-thumb" />
              <div class="upload-success-info">
                <span class="uploaded-badge">
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
                    <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  Uploaded successfully
                </span>
                <button type="button" class="btn-remove-logo" (click)="removeLogo()">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                    <path d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  Remove &amp; Re-upload
                </button>
              </div>
            </div>

            <p class="otp-error" *ngIf="logoUploadError">{{ logoUploadError }}</p>
          </div>

          <!-- Institute email verification -->
          <div class="verify-block">
            <p class="verify-block-label">Official Institute Email</p>

            <div class="verify-row" *ngIf="!registerForm.value.instituteEmailVerified">
              <div class="verify-input-wrap">
                <input
                  *ngIf="!instituteEmailOtpSent"
                  class="field-input"
                  formControlName="instituteEmail"
                  placeholder="info@institution.edu"
                  type="email"
                />
                <input
                  *ngIf="instituteEmailOtpSent"
                  class="field-input"
                  formControlName="instituteEmailOtp"
                  placeholder="Enter 6-digit OTP"
                  maxlength="6"
                />
              </div>
              <button type="button" class="btn-verify" *ngIf="!instituteEmailOtpSent" (click)="sendInstituteEmailOtp()" [disabled]="instituteEmailVerifying">
                {{ instituteEmailVerifying ? 'Sending…' : 'Send OTP' }}
              </button>
              <button type="button" class="btn-verify btn-confirm" *ngIf="instituteEmailOtpSent" (click)="verifyInstituteEmailOtp()" [disabled]="instituteEmailConfirming">
                {{ instituteEmailConfirming ? 'Verifying…' : 'Confirm OTP' }}
              </button>
            </div>

            <div class="verified-badge" *ngIf="registerForm.value.instituteEmailVerified">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              Email verified — {{ registerForm.get('instituteEmail')?.value }}
              <button type="button" class="btn-change" (click)="changeInstituteEmail()">Change Email</button>
            </div>
            <p class="otp-error" *ngIf="instituteEmailOtpError">{{ instituteEmailOtpError }}</p>
          </div>

          <div class="field-group">
            <label class="field-label">Description</label>
            <textarea class="field-input field-textarea" formControlName="description" placeholder="Brief overview of the institution..."></textarea>
          </div>

          <div class="grid-2">
            <div class="field-group">
              <label class="field-label">Website URL</label>
              <input class="field-input" formControlName="website" type="url" placeholder="https://institution.edu" />
            </div>
            <div class="field-group">
              <label class="field-label">Accreditation</label>
              <input class="field-input" formControlName="accreditation" type="text" placeholder="e.g. NAAC, CBSE" />
            </div>
          </div>
        </section>

        <!-- ════ ADDRESS DETAILS ════ -->
        <section class="form-section" formGroupName="location">
          <h2 class="section-heading">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            Address Details
          </h2>

          <div class="grid-2">
            <div class="field-group">
              <label class="field-label">Address Line 1 <span class="required">*</span></label>
              <input class="field-input" formControlName="addressLine1" type="text" placeholder="Street address" />
            </div>
            <div class="field-group">
              <label class="field-label">Address Line 2</label>
              <input class="field-input" formControlName="addressLine2" type="text" placeholder="Building, suite, etc." />
            </div>
            <div class="field-group">
              <label class="field-label">State <span class="required">*</span></label>
              <select class="field-input field-select" formControlName="stateId">
                <option value="">Select State</option>
                @for (s of states; track s.name) {
                  <option [value]="s.id">{{ s.name }}</option>
                }
              </select>
            </div>
            <div class="field-group">
              <label class="field-label">City <span class="required">*</span></label>
              <select class="field-input field-select" formControlName="cityId">
                <option value="">Select City</option>
                @for (c of cities; track c.name) {
                  <option [value]="c.id">{{ c.name }}</option>
                }
              </select>
            </div>
            <div class="field-group">
              <label class="field-label">Postal Code <span class="required">*</span></label>
              <input class="field-input" formControlName="postal_code" type="text" placeholder="380009" />
            </div>
            <div class="field-group">
              <label class="field-label">Location Type <span class="required">*</span></label>
              <select class="field-input field-select" formControlName="locationTypeId">
                <option value="">Select Type</option>
                @for (e of locationType; track e.value) {
                  <option [value]="e.value">{{ e.label }}</option>
                }
              </select>
            </div>
          </div>
        </section>

      </div>

      <!-- Form Footer -->
      <div class="form-footer">
        <button type="button" (click)="registerForm.reset()" class="btn-secondary">
          Reset Form
        </button>
        <button type="submit" class="btn-primary">
          Save & Continue
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
    </form>
  </div>
</div>
